import { SelfURIMap, SnowplowAnalyticsProperties } from './appTypings';
import { areenaApiClient } from '../common/utils';

export const areenaApi = {
  url: 'https://areena.api.yle.fi',
  uiClient: areenaApiClient,
  uiVersion: '10',
};

export const areenaAppConf = {
  url: 'https://areena-app-configuration.yle.fi/global/production.json',
};

export const locationsApi = 'https://locations.api.yle.fi';

export const mediaApiUrl = 'https://media.api.yle.fi/v6/';

export const playerApiUrl = 'https://player.api.yle.fi/v1/';

export const loginApiUrl = 'https://login.api.yle.fi/v1';

export const consentApiUrl = 'https://yle-consent-sdk.yle.fi/';

export const myOhjelmatDevIP = '';

export const selfUri: SelfURIMap = {
  elisa: 'https://elisa-areena.yle.fi',
  hbbtv: 'https://hbbtv-areena.yle.fi',
  philips: 'https://philips-areena.yle.fi',
  panasonic: 'https://panasonic-areena.yle.fi',
  vestel: 'https://vestel-areena.yle.fi',
  hisense: 'https://hisense-areena.yle.fi',
  tivo: 'https://tivo-areena.yle.fi',
  sony: 'https://sony-areena.yle.fi',
  ps4: 'https://playstation4-areena.yle.fi',
  ps5: 'https://playstation5-areena.yle.fi',
  telia: 'https://telia-areena.yle.fi',
  tizen: 'https://samsung-areena.yle.fi',
  webos: 'https://lg-areena.yle.fi',
};

export const finnpanelUrl = 'https://endpoint.finnpanel.fi';

export const profilesLocalStorageKey = 'profiles';

export const profileViewShownStorageKey = 'profile_view_shown';

export const introVideoShownStorageKey = 'intro_video_shown';

export const searchHistoryStorageKey = 'search_history';

export const cloudinaryHostname = 'images.cdn.yle.fi';

export const tunnusUrl = 'https://tunnus.yle.fi';

export const rememberLastProfileLocalStorageKey = 'remember_last_profile';

export const snowplowAnalyticsProperties: SnowplowAnalyticsProperties = {
  collectorUrl: 'haavi.yle.fi',
  getAppId: mode => `areena_leanback_${mode}-prod`,
  miniCollectorUrl: 'https://fi-yle-dev1.mini.snplow.net',
  trackerNamespace: 'sp1',
};
